export default defineI18nConfig(() => ({
    fallbackLocale: 'de',
    datetimeFormats: {
        'de': {
            dateTwoDigit: {
                year: '2-digit', month: '2-digit', day: '2-digit'
            },
            dateNumeric: {
                year: 'numeric', month: '2-digit', day: '2-digit'
            },
            dateShort: {
                year: 'numeric', month: 'short', day: 'numeric'
            },
            dateTimeShort: {
                year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
            },
            dateTimeNumeric: {
                year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', minute: 'numeric'
            },
            timeNumeric: {
                hour: 'numeric', minute: 'numeric'
            },
            dateLong: {
                year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric'
            },
        },
        'en': {
            dateShort: {
                year: 'numeric', month: 'short', day: 'numeric'
            },
            dateTimeShort: {
                year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
            },
        }
    }
}))